import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import {
  MultiEntityPickerRenderedString,
  MultiEntityPickerRenderedStringSchema,
  // validateMultiEntityPickerRenderedString
} from './MultiEntityPickerRenderedStringExtension';

export const MultiEntityPickerRenderedStringExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: MultiEntityPickerRenderedString,
    name: 'MultiEntityPickerRenderedString',
    schema: MultiEntityPickerRenderedStringSchema,
    // validation: validateMultiEntityPickerRenderedString,
  }),
);
